<template>
  <div>
    <!-- <v-layout column wrap justify-center v-if="!contractIsPending" pa-4>
      <contractSteps />
    </v-layout> -->

    <!-- <v-layout column wrap justify-center v-if="!contractIsPending" pa-4>
      <invoiceDetailForm :contractInvoiceDetails="true" />
    </v-layout> -->

    <v-dialog v-model="showScoreCostDialog" width="600" lazy>
      <scoreCostSupplier
        @closeBillDialog="closeBillDialog"
        :editedScoreCost="editedScoreCost"
      />
    </v-dialog>

    <v-alert
      color="orange"
      justify-center
      v-if="!supplierHaveProduct()"
      :value="true"
      type="error"
      transition="scale-transition"
    >
      The Supplier {{ contract.supplier_company_name }} is not selling any
      product.
    </v-alert>

    <v-layout column wrap justify-center v-if="supplierHaveProduct()" pa-4>
      <v-flex xs12 px-0>
        <productTrades
          :previsional="true"
          :editable="contractIsPending"
          :contractHaveProductTrades="contractHaveProductTrades()"
        />
      </v-flex>

      <v-flex
        my-3
        v-if="contractHaveProductTrades() && this.getNetWeightProducts() <= 0"
      >
        <v-layout row wrap justify-center>
          <span class="error--text">
            <v-icon class="error--text" small>warning</v-icon>Total net weight
            of products should not be null.
          </span>
        </v-layout>
      </v-flex>
      

      <v-flex
        xs12
        px-0
        my-3
        v-if="contractHaveProductTrades() && this.getNetWeightProducts() > 0"
      >
        <expeditions :previsional="true" :editable="contractIsPending" />
      </v-flex>

      <v-flex xs12 my-3 v-show="!netWeightAreEquals() && netWeightAreNotNull()">
        <v-alert :value="true" type="error">
          <div>
            The total net weight of products is different than the total net
            weight present in expeditions :
            {{ getNetWeightProducts() }} vs {{ getNetWeightExpeditions() }} mt.
            Fix this to be able to generate provisional score
          </div>
        </v-alert>
      </v-flex>

      <v-flex xs12 my-2 v-if="canGenerateScore() && contractIsPending">
        <v-layout row justify-center>
          <v-btn round @click="generatePrevisionnalScore" color="#d21933">
            <v-icon small color="white" class="pr-2">timeline</v-icon>
            <span style="color: white;">Generate provisional score</span>
          </v-btn>
        </v-layout>
      </v-flex>

      <v-flex>
        <v-layout column v-if="previsionalScoreGenerated()">
          <v-layout column>
            <v-flex my-2>
              <score-costs :previsional="true" :editable="contractIsPending" />
            </v-flex>
          </v-layout>

          <v-flex my-4>
            <totalScore :previsional="true" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import productTrades from "./productTrades";
import expeditions from "./expeditions";
import scoreCosts from "./scoreCosts";
import totalScore from "./totalScore";

import GENERATE_PREVISIONAL_SCORE from "../../graphql/contracts/generate_previsional_score.gql";
import scoreProducts from "../../mixins/scoreProducts";
import scoreCostSupplier from "./scoreCostSupplier";


export default {
  name: "previsionalScore",
  mixins: [scoreProducts],
  components: {
    scoreCostSupplier,

    productTrades,
    scoreCosts,
    totalScore,
    expeditions
 
  },
  data() {
    return {
      previsional: true,
      showScoreCostDialog: false,
    };
  },
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "real_expeditions",
      "previsional_expeditions",
      "editedScoreCost",
      /* "showScoreCostDialog" */
    ]),
    contractIsPending() {
      return this.contract.status === "pending";
    },
  },
  methods: {
    generatePrevisionnalScore() {
      this.sendMutation("generated", "score", GENERATE_PREVISIONAL_SCORE, {
        id: this.contract.id,
      });
    },
    previsionalScoreGenerated() {
      return this.contract.score_costs.length > 0;
    },
    closeBillDialog() {
      this.showScoreCostDialog = false;
    },
  },
  watch: {
    editedScoreCost() {
      if (this.editedScoreCost && this.editedScoreCost.id)
        this.showScoreCostDialog = true;
    },
    showScoreCostDialog() {
      if (!this.showScoreCostDialog) {
        this.$store.commit("contractStore/showScoreCostSupplier", {
          value: false,
          editedItem: {},
        });
      }
    },
  },
};
</script>
